export function toBase64(uuid: string) {
  return Buffer.from(uuid).toString('base64');
}

export function fromBase64(uuidBase64: string) {
  return Buffer.from(uuidBase64, 'base64').toString();
}
